import { useEffect, useState } from 'react';

export const useActiveSection = (
  sectionIds: (string | number)[],
  container: HTMLElement | null,
) => {
  const [activeId, setActiveId] = useState<string | number | null>(null);

  useEffect(() => {
    if (!container) return;

    const handleScroll = () => {
      for (const id of sectionIds) {
        const element = container.querySelector(`#${id}`);
        if (!element) continue;

        const rect = element.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        const offsetTop = rect.top - containerRect.top;

        if (offsetTop >= 0 && offsetTop < container.clientHeight / 2) {
          setActiveId(id);
          break;
        }
      }
    };

    container.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => {
      container.removeEventListener('scroll', handleScroll);
    };
  }, [sectionIds, container]);

  const handleScrollToSection = (id: string | number) =>
    container?.querySelector(`#${id}`)?.scrollIntoView({ behavior: 'smooth' });

  return { activeId, handleScrollToSection };
};
